import { render } from 'preact';
import { App } from './App';
import './estilos.css';

render(<App />, document.getElementById('app')!);
